"use strict";
/*-----------------------------------------------------------------------------
| Copyright (c) Jupyter Development Team.
| Distributed under the terms of the Modified BSD License.
|----------------------------------------------------------------------------*/

var _classCallCheck = require("/home/runner/work/RLeapFROGS/RLeapFROGS/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/RLeapFROGS/RLeapFROGS/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/home/runner/work/RLeapFROGS/RLeapFROGS/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/home/runner/work/RLeapFROGS/RLeapFROGS/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/home/runner/work/RLeapFROGS/RLeapFROGS/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var widgets_1 = require("@phosphor/widgets");
/**
 * The spinner class.
 */


var Spinner = /*#__PURE__*/function (_widgets_1$Widget) {
  _inherits(Spinner, _widgets_1$Widget);

  var _super = _createSuper(Spinner);

  /**
   * Construct a spinner widget.
   */
  function Spinner() {
    var _this;

    _classCallCheck(this, Spinner);

    _this = _super.call(this);

    _this.addClass('jp-Spinner');

    _this.node.tabIndex = -1;
    var content = document.createElement('div');
    content.className = 'jp-SpinnerContent';

    _this.node.appendChild(content);

    return _this;
  }
  /**
   * Handle `'activate-request'` messages.
   */


  _createClass(Spinner, [{
    key: "onActivateRequest",
    value: function onActivateRequest(msg) {
      this.node.focus();
    }
  }]);

  return Spinner;
}(widgets_1.Widget);

exports.Spinner = Spinner;